/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { SponsorshipType } from "./SponsorshipType";

export interface SponsorshipModel {
  type: SponsorshipType;
  partner_uid: string;
  name?: string | null;
}
